import * as Yup from 'yup';

export default Yup.object().shape({
  username: Yup.string().required('username required'),
  enabled: Yup.boolean().required('enabled required'),
  koinzaar_key: Yup.string(),
});
